import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { TbPlus, TbEdit, TbTrash } from 'react-icons/tb';

import EditAddStageModal from './EditAddStageModal';
import EditDeleteStageModal from './EditDeleteStageModal';
import StageEditeModal from './StageEditeModal';

const EditPipelineModal = ({ show, onHide, pipeline }) => {
  const [formData, setFormData] = useState({ name: '', stages: [] });

  // Stage Modals States
  const [showAddStage, setShowAddStage] = useState(false);
  const [showEditStage, setShowEditStage] = useState(false);
  const [showDeleteStage, setShowDeleteStage] = useState(false);
  const [editingStageIndex, setEditingStageIndex] = useState(null);
  const [deletingStageIndex, setDeletingStageIndex] = useState(null);

  useEffect(() => {
    if (pipeline) {
      setFormData({
        name: pipeline.name,
        stages: ["Inpipeline", "Follow Up", "Schedule Service"],
      });
    }
  }, [pipeline]);

  // Open Stage Modals (Close main modal first)
  const openAddStage = () => {
    onHide(); // Close Edit Pipeline modal
    setShowAddStage(true);
  };

  const openEditStage = (index) => {
    onHide(); // Close Edit Pipeline modal
    setEditingStageIndex(index);
    setShowEditStage(true);
  };

  const openDeleteStage = (index) => {
    onHide(); // Close Edit Pipeline modal
    setDeletingStageIndex(index);
    setShowDeleteStage(true);
  };

  // Re-open main modal after stage modal closes
  const handleStageModalClose = () => {
    setShowAddStage(false);
    setShowEditStage(false);
    setShowDeleteStage(false);
    setEditingStageIndex(null);
    setDeletingStageIndex(null);

    // Re-open Edit Pipeline modal after small delay for smooth UX
    setTimeout(() => {
      // If you want to re-open automatically, you can pass a callback from parent
      // For now, user can click Edit icon again
    }, 300);
  };

  const addNewStage = (newStageName) => {
    setFormData(prev => ({
      ...prev,
      stages: [...prev.stages, newStageName]
    }));
  };

  const updateStage = (index, newName) => {
    setFormData(prev => {
      const updatedStages = [...prev.stages];
      updatedStages[index] = newName;
      return { ...prev, stages: updatedStages };
    });
  };

  const removeStage = (index) => {
    setFormData(prev => ({
      ...prev,
      stages: prev.stages.filter((_, i) => i !== index)
    }));
  };

  return (
    <>
      {/* ===================== MAIN EDIT PIPELINE MODAL ===================== */}
      <Modal 
        show={show} 
        onHide={onHide} 
        centered 
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-semibold fs-4">Edit Pipeline</Modal.Title>
        </Modal.Header>

        <Modal.Body className="pt-3 px-4">
          <Form>
            <Form.Group className="mb-4">
              <Form.Label className="fw-medium">
                Pipeline Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="py-3 rounded-3"
              />
            </Form.Group>

            {/* Pipeline Stages */}
            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <Form.Label className="fw-medium mb-0">
                  Pipeline Stages <span className="text-danger">*</span>
                </Form.Label>
            
                        <Button style={{ color: "#ff6b1a"}}
                                  variant=""
                                  className="text-orange fw-medium p-0 d-flex align-items-center"
                                   onClick={openAddStage}
                                >
                                  <TbPlus size={20} className="me-1" />
                                  Add New
                                </Button>
              </div>

              {formData.stages.map((stage, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center gap-3 mb-3 p-3 bg-light border rounded-3"
                >
                  <div className="text-muted fs-5">⋮⋮</div>
                  <Form.Control
                    type="text"
                    value={stage}
                    readOnly
                    className="flex-grow-1 border-0 bg-transparent shadow-none py-2"
                  />
                  <div className="d-flex gap-2">
                    <Button
                      variant="light"
                      size="sm"
                      className="p-2"
                      onClick={() => openEditStage(index)}
                    >
                      <TbEdit size={18} />
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="p-2 text-danger"
                      onClick={() => openDeleteStage(index)}
                    >
                      <TbTrash size={18} />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </Form>
        </Modal.Body>

        <Modal.Footer className="border-0 pt-2 pb-4 px-4">
          <Button variant="light" className="px-4" onClick={onHide}>
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: '#FF6B00', borderColor: '#FF6B00' }}
            className="px-4"
            onClick={onHide}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <EditAddStageModal
        show={showAddStage}
        onHide={handleStageModalClose}
        onAdd={addNewStage}
      />

      <StageEditeModal
        show={showEditStage}
        onHide={handleStageModalClose}
        currentName={formData.stages[editingStageIndex]}
        onSave={(newName) => updateStage(editingStageIndex, newName)}
      />

      <EditDeleteStageModal
        show={showDeleteStage}
        onHide={handleStageModalClose}
        stageName={formData.stages[deletingStageIndex]}
        onConfirm={() => {
          removeStage(deletingStageIndex);
          handleStageModalClose();
        }}
      />
    </>
  );
};

export default EditPipelineModal;